var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{class:[_vm.defaultColor ? 'is-default' : '', 'fa'],attrs:{"icon":"user-plus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }